import { Sync } from "@sicarx/sxw-api"

export interface IncomingData {
    contentId: number
    authToken: string
    platform: string
    priceListId: string
    tokens?: Sync.MapTokens
    paginationTokens?: Partial<Sync.MapTokens>
}

export interface IncomingDataDocuments {
    contentId: number,
    branchId: number,
    userAccount: string
    authToken: string
    platform: string
    isInmediate?: boolean
}


export enum SyncEvents {
    STOP_CATALOG = 'STOP_CATALOG',
    START_CATALOG = 'START_CATALOG',
    STOP_SALES = 'STOP_SALES',
    START_SALES = 'START_SALES',
    CLOSE = 'CLOSE'
}

export enum IncomingAction {
    INIT_SYNC = "INIT_SYNC",
    SYNC_ONLY_PRICES = "SYNC_ONLY_PRICES",
    SUBSCRIBE = "SUBSCRIBE",
    DOCUMENTS = 'DOCUMENTS',
    START_SYNC_CATALOG = SyncEvents.START_CATALOG,
    STOP_SYNC_CATALOG = SyncEvents.STOP_CATALOG,
    START_SYNC_SALES = SyncEvents.START_SALES,
    STOP_SYNC_SALES = SyncEvents.STOP_SALES
}

export enum OutgoingAction {
    SET_TOKENS = "SET_TOKENS",
    SET_COMPLETED = "SET_COMPLETED",
    SUBSCRIBE = "SUBSCRIBE",
    RECONNECT = 'RECONNECT',
    SET_PAGINATION_TOKENS = "SET_PAGINATION_TOKENS",
    SYNC = 'SYNC',
    SYNC_SALES = 'SYNC_SALES',
    SET_LAST_SALE = 'SET_LAST_SALE',
    SYNC_ERROR = 'SYNC_ERROR',
    PANIC = 'PANIC'
}


export type Incoming = {
    [IncomingAction.INIT_SYNC]: IncomingData
    [IncomingAction.SUBSCRIBE]: IncomingData,
    [IncomingAction.SYNC_ONLY_PRICES]: IncomingData
    [IncomingAction.DOCUMENTS]: IncomingDataDocuments
    [IncomingAction.STOP_SYNC_CATALOG]: null,
    [IncomingAction.STOP_SYNC_SALES]: null
}


export type Outgoing = {
    [OutgoingAction.SET_PAGINATION_TOKENS]: Partial<Sync.MapTokens>
    [OutgoingAction.SET_TOKENS]: Sync.MapTokens
    [OutgoingAction.SUBSCRIBE]: undefined
    [OutgoingAction.RECONNECT]: undefined
    [OutgoingAction.SET_COMPLETED]: boolean,
    [OutgoingAction.SYNC]: boolean
    [OutgoingAction.SYNC_SALES]: boolean
    [OutgoingAction.SET_LAST_SALE]: Record<string, any>
    [OutgoingAction.PANIC]: boolean
    [OutgoingAction.SYNC_ERROR]: { payload: Partial<Sync.SyncDocument>, error: string, isBackError: boolean }

}

export type Update<K, C> = {
    key: K
    changes: C
}